import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {USERS_STATE_NAME, UsersState} from "./users";
import {selectSites} from "../init/init.selectors";
import {Serializers} from "../../interfaces/serializer";
import {Site} from "../../interfaces/site";
import {User} from '../../interfaces/user';
import {UserComponentObjects} from '../../classes/user-component-object';

export const selectUsersState = createFeatureSelector<UsersState>(USERS_STATE_NAME);

export const selectUsers: MemoizedSelector<object, Serializers<User>> = createSelector(
  selectUsersState,
  (usersState: UsersState) => usersState.users
);

export const selectUserComponentObjects: MemoizedSelector<object, UserComponentObjects> = createSelector(
  selectUsersState,
  (usersState: UsersState) => usersState.componentObjects
);

export const selectUsersData: MemoizedSelector<object, { users: Serializers<User>, sites: Serializers<Site> }> = createSelector(
  selectUsersState,
  selectSites,
  (usersState: UsersState, sites: Serializers<Site>) => ({users: usersState.users, sites})
);

export const selectUsersLoading: MemoizedSelector<object, boolean> = createSelector(
  selectUsersState,
  (usersState: UsersState) => usersState.loading
);

export const selectUsersCanCreate: MemoizedSelector<object, boolean> = createSelector(
  selectUsersState,
  (usersState: UsersState) => usersState.canCreate
);

export const selectUsersLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectUsersState,
  (usersState: UsersState) => usersState.loaded
);
